module.exports = __webpack_public_path__ + "static/media/globe.aa634ef8.svg";